"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.Title = exports.Text = exports.Item = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Item = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
    border-bottom: 1px solid ${theme.palette.border.default};
    position: relative;
    &:last-of-type {
      border-bottom: none;
    }
  `}
`;
exports.Text = styled_components_1.default.div `
  ${({ theme }) => (0, styled_components_1.css) `
    margin: 0;
    box-sizing: border-box;
    font-weight: 500;
    color: ${theme.palette.text.default};
  `}
`;
exports.Title = styled_components_1.default.button `
  ${({ expanded }) => (0, styled_components_1.css) `
    font-family: inherit;
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
    background: none;
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    text-align: left;
    cursor: ${expanded ? "default" : "pointer"};
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    & > h4 {
      margin: 0;
      padding: 0;
    }
  `}
`;
exports.Content = styled_components_1.default.div `
  ${({ theme, expanded }) => (0, styled_components_1.css) `
    box-sizing: border-box;
    height: 0;
    overflow: ${expanded ? "visible" : "hidden"};

    transition: all ${theme.transitions.duration.default}ms
      ${theme.transitions.easing.easeInOut};
  `}
`;
//# sourceMappingURL=styled.js.map